export const OPEN_UPGRADE_MODAL = '[Upgrade Modal] Open Modal';
export const CLOSE_UPGRADE_MODAL = '[Upgrade Modal] Close Modal';

export const openUpgradeModal = (url) => ({ type: OPEN_UPGRADE_MODAL, url });
export const closeUpgradeModal = () => ({ type: CLOSE_UPGRADE_MODAL });
